export default "__VITE_ASSET__DkEZXl1i__"